import { Injectable } from '@angular/core';

import { Address } from '../../models/address';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class AddressService extends BackendBaseService {
  /**
   * Base URL for Address resource
   * @type {String}
   */
  url = 'addresses';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  addressesByTypeName(contact_id: number, type_name: string): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { address_type_name: type_name, contact_id: contact_id });
  }

  getAddresses(data: any) {
    return this.httpClient.get(`${this.url}.json`, data).catch(function () {});
  }

  /**
   * Get matching address using an address search
   * @param  {number}       contactId contact id
   * @param  {string}       address   address string to search
   * @return {Promise<any>}           Server response
   */
  geocode(contactId: number, address: string): Promise<any> {
    return this.httpClient.post(`${this.url}/geocode.json`, { contact_id: contactId, address: address });
  }

  /**
   * CREATE and UPDATE actions for Address resource
   * @param  {Address} address Address to be saved
   * @return {Promise<any>} Save response
   */
  save(address: Address): Promise<any> {
    return super.save({
      contact_id: address.contact_id,
      address: address,
      id: address.id
    });
  }

  /**
   * Update positions of addresses of a contact
   * @param  {number}           contactId Contact id
   * @param  {Array<number> =         []}          address_ids Address ids in order
   * @return {Promise<any>}               Server response
   */
  updatePositions(contactId: number, address_ids: Array<number> = []): Promise<any> {
    return this.httpClient.put(`${this.url}/update_positions.json`, { contact_id: contactId, address_ids: address_ids });
  }

  getContact(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/get_contact.json`, params);
  }
}
